var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BROADCAST_CHANNEL, windowExist } from 'src/shared/constants';
export var E_BROADCAST_MESSAGE;
(function (E_BROADCAST_MESSAGE) {
    E_BROADCAST_MESSAGE["STOP_STREAM"] = "STOP_STREAM";
    E_BROADCAST_MESSAGE["DISCONNECT"] = "DISCONNECT";
})(E_BROADCAST_MESSAGE || (E_BROADCAST_MESSAGE = {}));
export var broadcastToAllTabs = function (key, data) {
    if (windowExist) {
        var broadcastChannel = new BroadcastChannel(BROADCAST_CHANNEL);
        broadcastChannel.postMessage({ key: key, data: data });
    }
};
export var listenToBroadcast = function (key, callback) {
    if (windowExist) {
        // We need to store the ids listened to avoid calling the callback multiple times, warning each listener is gonna have to manage its own ids
        var idsListened_1 = [];
        var broadcastChannel_1 = new BroadcastChannel(BROADCAST_CHANNEL);
        broadcastChannel_1.onmessage = function (event) {
            var _a = event.data, keyMessage = _a.key, data = _a.data;
            var id = (data || {}).id;
            var idAlreadyListened = idsListened_1.includes(id);
            if (key === keyMessage && !idAlreadyListened) {
                if (id) {
                    idsListened_1.push(id);
                }
                callback(data);
            }
        };
        return function () { return broadcastChannel_1.close(); };
    }
};
export var onTabClose = function (callback) {
    if (windowExist) {
        window.addEventListener('beforeunload', callback);
        return function () { return window.removeEventListener('beforeunload', callback); };
    }
};
export var onTabFocus = function (callback) {
    if (windowExist) {
        var eventMethod_1 = function (e) {
            if (!e.target.hidden) {
                callback();
            }
        };
        window.addEventListener('visibilitychange', eventMethod_1);
        return function () { return window.removeEventListener('visibilitychange', eventMethod_1); };
    }
};
export var onTabBlur = function (callback) {
    if (windowExist) {
        var eventMethod_2 = function (e) {
            if (e.target.hidden) {
                callback();
            }
        };
        window.addEventListener('visibilitychange', eventMethod_2);
        return function () { return window.removeEventListener('visibilitychange', eventMethod_2); };
    }
};
export var requestNotificationPermission = function () { return __awaiter(void 0, void 0, void 0, function () {
    var hasNotificationSupport, permission, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                hasNotificationSupport = windowExist && 'Notification' in window;
                if (!hasNotificationSupport) {
                    return [2 /*return*/, null];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Notification.requestPermission()];
            case 2:
                permission = _b.sent();
                return [2 /*return*/, permission];
            case 3:
                _a = _b.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var isPageInactive = function () {
    if (!windowExist || typeof document === 'undefined') {
        return false;
    }
    var isDocumentHidden = Boolean(document.hidden);
    var hasDocumentFocus = typeof document.hasFocus === 'function' ? document.hasFocus() : true;
    var isInactive = isDocumentHidden || !hasDocumentFocus;
    return isInactive;
};
export var sendBrowserNotification = function (options) {
    var title = options.title, body = options.body, onClick = options.onClick;
    var hasNotificationSupport = windowExist && 'Notification' in window;
    var isPermissionGranted = hasNotificationSupport && Notification.permission === 'granted';
    if (!isPermissionGranted) {
        return null;
    }
    var activeNotifications = new Set();
    try {
        var notification_1 = new Notification(title, { body: body });
        activeNotifications.add(notification_1);
        var cleanupNotification_1 = function () {
            activeNotifications.delete(notification_1);
        };
        notification_1.onclose = function () {
            cleanupNotification_1();
        };
        notification_1.onerror = function () {
            cleanupNotification_1();
        };
        notification_1.onclick = function () {
            cleanupNotification_1();
            if (windowExist) {
                window.focus();
            }
            if (onClick) {
                onClick();
            }
            notification_1.close();
        };
        return notification_1;
    }
    catch (_a) {
        return null;
    }
};
